module.exports = __webpack_public_path__ + "static/media/banner1.57839e83.png";